import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';

import { cartPopupReducer } from './cart-popup.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('cartPopup', cartPopupReducer)],
    exports: [],
    providers: [],
})
export class CartPopupStateModule {}
